import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';

import { RequestType } from '../../../types/enums/request-enums';

const GetServiceList = (params: any) =>
    request({
        url: ApiURL.Query.getServiceList,
        method: RequestType.GET,
        params: params,
    });

const GetScheduleHistory = (params: any) =>
    request({
        url: ApiURL.Query.getScheduleHistory,
        method: RequestType.GET,
        params: params,
    });

const GetScheduleGroups = () =>
    request({
        url: ApiURL.Query.getScheduleGroups,
        method: RequestType.GET,
    });

const GetUserScheduleGroups = () =>
    request({
        url: ApiURL.Query.getUserScheduleGroups,
        method: RequestType.GET,
    });

const ScheduleServiceQuery = {
    GetServiceList,
    GetScheduleHistory,
    GetScheduleGroups,
    GetUserScheduleGroups,
};

export default ScheduleServiceQuery;
